module.exports = __webpack_public_path__ + "static/media/PDF.5fc7c69d.svg";